/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddImageRateCommand } from '../../models/add-image-rate-command';
import { AddImageRateCommandResult } from '../../models/add-image-rate-command-result';

export interface ApiKpiReportsAddImageRateToNotePost$Params {
      body?: AddImageRateCommand
}

export function apiKpiReportsAddImageRateToNotePost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsAddImageRateToNotePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddImageRateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsAddImageRateToNotePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddImageRateCommandResult>;
    })
  );
}

apiKpiReportsAddImageRateToNotePost.PATH = '/api/KPIReports/AddImageRateToNote';
